export enum ModeDnd {
  Moving = 'Перемещение',
  Duplication = 'Дублирование',
}

export enum TableSortOrder {
  Time = 'time',
  TaskKey = 'taskKey',
}

export type WorkTime = '40' | '30' | '20';
